/* eslint-disable react/no-array-index-key */
import { Heading } from '@mm/components';
import { useViewActions } from '@mm/state/actions/viewActions';
import { LinkTypes } from '@mm/state/model/PromoterModel';
import { KnownSiteType } from '@mm/stateful-components/ChatWidget/InstallationGuide/constants';
import { InstallationGuide } from '@mm/stateful-components/ChatWidget/InstallationGuide/InstallationGuide';
import React, { useState } from 'react';
import { GreenMarker } from '../../../../../../common/components/GreenMarker/GreenMarker';
import { useDetectOutsideClicks } from '../../../../../../common/hooks/use-detect-outside-clicks';
import { useGreenCueMarkers } from '../../../../../../common/hooks/use-green-cue-markers';
import { ZoomImageModal } from '../../../../../../common/modals/ZoomImageModal/ZoomImageModal';
import { SlideoutMenu } from '../../../../../components/SlideoutMenu/components/SlideoutMenu';
import styles from './CustomerChatInstallationGuideSlideoutMenu.module.css';

type Props = {
  siteType: KnownSiteType;
  promoterJSCode: string;
  promoterJSCode2?: string;
  promoterType: LinkTypes;
  onCopyClick?: () => void;
};

export const CustomerChatInstallationGuideSlideoutMenu = ({
  siteType,
  promoterJSCode,
  promoterJSCode2,
  promoterType,
  onCopyClick,
}: Props) => {
  const { hideSlideoutMenu } = useViewActions();
  const [zoomImage, setZoomImage] = useState<string>();
  const [wrapperRef, setWrapperRef] = useState<HTMLElement | null>(null);

  const { isWebChatActivated } = useGreenCueMarkers();

  const setRef = (ref: HTMLElement) => {
    setWrapperRef(ref);
  };
  useDetectOutsideClicks(() => {
    if (!zoomImage) {
      hideSlideoutMenu();
    }
  }, wrapperRef);

  return (
    <>
      {zoomImage && (
        <ZoomImageModal
          displayImageSrc={zoomImage}
          closeModal={() => setZoomImage(undefined)}
          fileName=""
          personName=""
          zIndex={10000004}
        />
      )}

      <SlideoutMenu setRef={setRef} className={styles.menu}>
        <SlideoutMenu.Header closeIcon="outlinedClose">
          <Heading className={styles.heading} size={3}>
            {!isWebChatActivated && <GreenMarker />}
            <div>{siteType} Installation Guide</div>
          </Heading>
        </SlideoutMenu.Header>
        <SlideoutMenu.Content>
          <InstallationGuide
            siteType={siteType}
            promoterJSCode={promoterJSCode}
            promoterJSCode2={promoterJSCode2}
            promoterType={promoterType}
            onImageClick={setZoomImage}
            onCopyClick={onCopyClick}
            usedInSlideout
          />
        </SlideoutMenu.Content>
      </SlideoutMenu>
    </>
  );
};
